import { render, staticRenderFns } from "./examineStaffManageList.vue?vue&type=template&id=89cdd620&scoped=true"
import script from "./examineStaffManageList.vue?vue&type=script&lang=js"
export * from "./examineStaffManageList.vue?vue&type=script&lang=js"
import style0 from "./examineStaffManageList.vue?vue&type=style&index=0&id=89cdd620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cdd620",
  null
  
)

export default component.exports